import baseService from '../../../lib/service/ServiceBase';
import { getVal } from '../../../lib/utils/UtilsCommon';

const PREFIX: string = 'EVALUATION_';

export const INIT_EVALUATION_DATA: string = PREFIX + 'INIT_EVALUATION_DATA';
export const GET_EVALUATION_LIST: string = PREFIX + 'GET_EVALUATION_LIST';
export const UPDATE_EVALUATION_LIST: string = PREFIX + 'UPDATE_EVALUATION_LIST';

/**
 * 初始化评价
 */
export function initEvaluationData(evaluationData: any): any {
	return {
		type: INIT_EVALUATION_DATA,
		evaluationData,
	};
}

/**
 * 获取评价列表
 */
export function getEvaluationList(d: any): any {
	const {
		isContinue, // 是否继续加载
		hasValidFilter, // 有效评价过滤开关
		...params
	} = d;

	return (dispatch: any, getStore: any): any => {
		const storeKey: string = hasValidFilter ? 'evaluationListValid' : 'evaluationList';
		const asyncObj: any = getStore().evaluation[storeKey];
		if (/pending|end/.test(asyncObj.status)) return null;

		const page: any = { ...asyncObj.page, ...params.page };
		page.page = isContinue && asyncObj.data ? Number(page.page) + 1 : 1;
		params.page = page;

		params.onlyContent = hasValidFilter ? 'Y' : 'N';

		dispatch({
			type: GET_EVALUATION_LIST,
			hasValidFilter,
			data: {
				...asyncObj,
				status: 'pending',
			},
		});

		return baseService
			.commonApi({
				url: '/h5/evaluate/list',
				body: params,
			})
			.then((res: any): any => {
				if (res.state.code) throw Error(res.state.msg);

				const list: any[] = res.data.list || [];
				const status: string = list.length < page.size ? 'end' : 'success';

				const asyncObj: any = getStore().evaluation[storeKey];

				dispatch({
					type: GET_EVALUATION_LIST,
					hasValidFilter,
					data: {
						...asyncObj,
						data: isContinue ? (asyncObj.data || []).concat(list) : list,
						status,
						page,
					},
				});
			})
			.catch((err: any): void => {
				console.log(err);

				dispatch({
					type: GET_EVALUATION_LIST,
					hasValidFilter,
					data: {
						...getStore().evaluation[storeKey],
						status: '',
					},
				});
			});
	};
}

/**
 * 更新评价列表
 */
export function updateEvaluationList(list: any[]): any {
	return {
		type: UPDATE_EVALUATION_LIST,
		list,
	};
}
